import { format, parseISO, isValid } from "date-fns";

// Notification dates can arrive null or malformed; parseISO(null) throws on
// `.split`, so guard first and return null when there is no valid date.
export const formatNotificationDate = (value) => {
  if (!value) return null;
  const parsed = parseISO(value);
  return isValid(parsed) ? format(parsed, "dd MMMM, yyyy") : null;
};
